import { useEffect } from 'react';
import { applyPageMeta, SITE_URL } from '@/lib/pageMeta';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProvidersCarousel from './components/ProvidersCarousel';
import FeaturesSection from './components/FeaturesSection';
import PromotionsSection from './components/PromotionsSection';
import PlayFeaturesSection from './components/PlayFeaturesSection';
import SlotsSection from './components/SlotsSection';
import LiveCasinoSection from './components/LiveCasinoSection';
import WhyChooseSection from './components/WhyChooseSection';
import MissionFAQSection from './components/MissionFAQSection';
import ContactCTASection from './components/ContactCTASection';
import Footer from './components/Footer';

const HOME_TITLE = 'PNGGO | PGK Friendly Ewallet Online Casino';
const HOME_DESCRIPTION =
  "Play at PNGGO — Papua New Guinea's Asia-leading online casino: slot games, live casino, lottery & poker in PGK. PSGA Verified platform with Kina Bank & BSP banking, daily promos, and 24/7 support for PNG players.";
const HOME_KEYWORDS =
  'PNGGO, Papua New Guinea online casino, Asia leading casino, PNG slots, live casino PNG, online lottery PNG, online poker PNG, PSGA verified, PGK casino, Kina Bank, BSP';
const HOME_OG_DESCRIPTION =
  'PNGGO — Asia-leading online casino for Papua New Guinea. Slots, live casino, lottery & poker in PGK. PSGA Verified. Kina Bank & BSP, promos & 24/7 support.';
const HOME_TW_DESCRIPTION =
    'Slots, live casino, lottery & poker in PGK at PNGGO — PSGA Verified. Built for Papua New Guinea with local banking & round-the-clock support.';

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      "url": SITE_URL,
      "name": "PNGGO",
      "alternateName": ["PNGGO.me", "PNGGO Papua New Guinea"],
      "description": HOME_DESCRIPTION,
      "inLanguage": "en-PG",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${SITE_URL}/?s={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "Organization",
      "@id": `${SITE_URL}/#organization`,
      "name": "PNGGO",
      "alternateName": ["PNGGO.me"],
      "url": SITE_URL,
      "logo": {
        "@type": "ImageObject",
        "url": `${SITE_URL}/favicon.png`
      },
      "description": HOME_DESCRIPTION,
      "areaServed": {
        "@type": "Country",
        "name": "Papua New Guinea"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "availableLanguage": "English",
        "hoursAvailable": "Mo-Su 00:00-23:59"
      }
    },
    {
      "@type": "WebPage",
      "@id": `${SITE_URL}/#webpage`,
      "url": SITE_URL,
      "name": HOME_TITLE,
      "description": HOME_DESCRIPTION,
      "isPartOf": { "@id": `${SITE_URL}/#website` },
      "about": { "@id": `${SITE_URL}/#organization` },
      "inLanguage": "en-PG"
    }
  ]
};

export default function HomePage() {
  useEffect(() => {
    applyPageMeta({
      title: HOME_TITLE,
      description: HOME_DESCRIPTION,
      path: '/',
      keywords: HOME_KEYWORDS,
      ogDescription: HOME_OG_DESCRIPTION,
      twitterDescription: HOME_TW_DESCRIPTION,
    });
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'home-jsonld';
    script.text = JSON.stringify(homeJsonLd);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('home-jsonld');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] pnggo-page-motif">
      <Navbar />
      <HeroSection />
      <ProvidersCarousel />
      <FeaturesSection />
      <PromotionsSection />
      <PlayFeaturesSection />
      <SlotsSection />
      <LiveCasinoSection />
      <WhyChooseSection />
      <MissionFAQSection />
      <ContactCTASection />
      <Footer />
    </div>
  );
}
